import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

export default function rangeSlider() {
    if ($('[data-range-slider]').length > 0) {
        let rangeSlider = $('[data-range-slider]')[0],
            input0 = $('[data-range-input-0]')[0],
            input1 = $('[data-range-input-1]')[0],
            inputs = [input0, input1],
            inputMin = $('[data-range-input-0]'),
            inputMax = $('[data-range-input-1]'),
            minVal = inputMin.data('min-range'),
            maxVal = inputMax.data('max-range'),
            minActualVal = inputMin.data('min-actual'),
            maxActualVal = inputMax.data('max-actual');

        noUiSlider.create(rangeSlider, {
            start: [minActualVal, maxActualVal],
            connect: true,
            decimals: 0,
            step: 1,
            margin: 0,
            range: {
                'min': minVal,
                'max': maxVal
            },
            format: wNumb({
                decimals: 0,
            })
        });

        rangeSlider.noUiSlider.on('update', function (values, handle) {
            inputs[handle].value = values[handle];
        });

        inputs.forEach(function (input, handle) {

            input.addEventListener('change', function () {
                rangeSlider.noUiSlider.setHandle(handle, this.value);
            });

            input.addEventListener('keydown', function (e) {

                let values = rangeSlider.noUiSlider.get();
                let value = Number(values[handle]);

                let steps = rangeSlider.noUiSlider.steps();

                let step = steps[handle];

                let position;

                switch (e.which) {

                    case 13:
                        rangeSlider.noUiSlider.setHandle(handle, this.value);
                        break;

                    case 38:
                        position = step[1];

                        if (position === false) {
                            position = 1;
                        }

                        if (position !== null) {
                            rangeSlider.noUiSlider.setHandle(handle, value + position);
                        }

                        break;

                    case 40:

                        position = step[0];

                        if (position === false) {
                            position = 1;
                        }

                        if (position !== null) {
                            rangeSlider.noUiSlider.setHandle(handle, value - position);
                        }

                        break;
                }
            });
        });
    }
}